import './style.css'
import * as dat from 'lil-gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import vertexShader from './shaders/smoke/vertex.glsl'
import fragmentShader from './shaders/smoke/fragment.glsl'


/**
 * Base
 */
// Debug

const debugObject = {}

const gui = new dat.GUI({
    width: 400
})

// Coment out for debug
gui.destroy()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()

// Draco loader
const dracoLoader = new DRACOLoader()
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader()
gltfLoader.setDRACOLoader(dracoLoader)

/**
 * Textures
 */

const bakedTexture = textureLoader.load('bakedCyber.jpg')
bakedTexture.flipY = false

const bakedBlinds = textureLoader.load('bakedBlinds.jpg')
bakedBlinds.flipY = false

// encoding needed on input but also output below
bakedTexture.encoding = THREE.sRGBEncoding
bakedBlinds.encoding = THREE.sRGBEncoding

const metalTexture = textureLoader.load('metal.jpg')

console.log(metalTexture)

metalTexture.repeat.set(5000, 1)

/**
 * Materials
 */

// Baked materials
const bakedMaterial = new THREE.MeshBasicMaterial({map: bakedTexture})
const blackMat = new THREE.MeshBasicMaterial({color: 0x030303})
const blindsMaterial = new THREE.MeshBasicMaterial({map: bakedBlinds})

// Pole lights
const poleLightMaterial = new THREE.MeshBasicMaterial({color: 0xffffe5})

// Metal grate
const metalMat = new THREE.MeshBasicMaterial({map: metalTexture, color: 0x662744})


gltfLoader.load(
    'cyberpunk2.glb',
    (gltf) => {
        // Traverse needed if multiple children, not needed with baked child
        gltf.scene.traverse((child) => {
            child.material = bakedMaterial
        })

        const wiresMesh1 = gltf.scene.children.find(child => child.name === 'Vert008')
        const wiresMesh2 = gltf.scene.children.find(child => child.name === 'Vert011')
        const wiresMesh3 = gltf.scene.children.find(child => child.name === 'Vert010')
        const wiresMesh4 = gltf.scene.children.find(child => child.name === 'wiresBack')
        const wiresMesh5 = gltf.scene.children.find(child => child.name === 'railing')
        const wiresMesh6 = gltf.scene.children.find(child => child.name === 'acWires')

        wiresMesh1.material = blackMat
        wiresMesh2.material = blackMat
        wiresMesh3.material = blackMat
        wiresMesh4.material = blackMat
        wiresMesh5.material = blackMat
        wiresMesh6.material = blackMat


        const blinds = gltf.scene.children.find(child => child.name === 'rightHouseBlinds')
        blinds.material = blindsMaterial

        const acOne = gltf.scene.children.find(child => child.name === 'acOne')
        const grateOne = acOne.children[3]

        console.log(grateOne)
        
        const grateTwo = gltf.scene.children.find(child => child.name === 'grateTwo')

        grateOne.material = metalMat
        grateTwo.material = metalMat

        scene.add(gltf.scene)
    }

)

/**
 * Raycaster
 */

 const raycaster = new THREE.Raycaster()

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    // update smoke shader aspect ratio
    smokeParticles.updateAspect()

})

/**
 * Listener for mouse position to detect hovers
 */

 const mouse = new THREE.Vector2()

 window.addEventListener('mousemove', (_event) => {
     mouse.x = _event.clientX / sizes.width * 2 - 1
     mouse.y = - (_event.clientY / sizes.height) * 2 + 1
 
 })

 /**
 * Click events
 */

window.addEventListener('mousedown', () => {
    if(currentIntersect) {
        
        switch(currentIntersect.object.name) {
            case 'portalLight':
                window.open('https://github.com/willdebras');
                break
            // Could add handling for other objects here, need to add to objectsToIntersect and replace with portal in tick function below
            case 'poleLightA':
                console.log('click on object 2')
                break

            case 'poleLightB':
                console.log('click on object 3')
                break
        }

    }
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 9
camera.position.y = 5
camera.position.z = 13
scene.add(camera)

gui.add(camera.position, 'x', -20, 20, 0.0001).name('camx')
gui.add(camera.position, 'y', -20, 20, 0.0001).name('camy')
gui.add(camera.position, 'z', -20, 20, 0.0001).name('camz')


class ParticleSystem {
  constructor (texture, emit_every, particle_life) {
    this.texture = texture;
    this.emit_every = emit_every;
    this.particle_life = particle_life;
    this.last_emission = 0;
 
    this.geometry = new THREE.BufferGeometry();
    this.particles = [];
    this.material = new THREE.ShaderMaterial({
      uniforms: {
        diffuseTexture: { value: texture },
        pointMultiplier: { value: window.innerHeight / window.innerWidth }
      },
      vertexShader,
      fragmentShader,
      blending: THREE.NormalBlending,
      depthTest: true,
      depthWrite: false,
      transparent: true,
      vertexColors: true,
    });
 
    this.mesh = new THREE.Points(this.geometry, this.material);
    this.clock = new THREE.Clock();
  }
 
  setPosition(position) {
    this.mesh.position.x = position.x;
    this.mesh.position.y = position.y;
    this.mesh.position.z = position.z;
  }
 
  getMesh() {
    return this.mesh;
  }
 
  updateAspect() {
    this.material.uniforms.pointMultiplier.value = window.innerHeight / window.innerWidth;
  }
 
  spawn() {
    this.particles.push({
      position: [0, 0, 0],
      scale: 0.4,
      alpha: 1,
      spawnTime: this.clock.elapsedTime,
    });
 
    this.last_emission = this.clock.elapsedTime;
  }
 
  update() {
    const elapsedTime = this.clock.getElapsedTime();
 
    this.particles = this.particles.filter((particle) => elapsedTime - particle.spawnTime < this.particle_life);
 
    if (elapsedTime - this.last_emission >= this.emit_every) {
      this.spawn();
    }
 
    this.geometry.setAttribute("position", new THREE.Float32BufferAttribute(this.particles.map((particle) => particle.position).flat(), 3));
    this.geometry.setAttribute("scale", new THREE.Float32BufferAttribute(this.particles.map((particle) => particle.scale).flat(), 1));
    this.geometry.setAttribute("alpha", new THREE.Float32BufferAttribute(this.particles.map((particle) => particle.alpha).flat(), 1));
    this.geometry.attributes.position.needsUpdate = true;
    this.geometry.attributes.scale.needsUpdate = true;
  }
}

class SmokeParticleSystem extends ParticleSystem {
    spawn() {
      super.spawn();
      this.particles[this.particles.length - 1].dartX = Math.random() * 0.003
      this.particles[this.particles.length - 1].dartZ = Math.random() * 0.003
    }
   
    update() {
      for (let i = 0; i < this.particles.length; i++) {
        this.particles[i].position[0] += this.particles[i].dartX;
        this.particles[i].position[1] += 0.007;
        this.particles[i].position[2] += this.particles[i].dartZ;
        this.particles[i].scale += 0.008;
        this.particles[i].alpha -= 0.005;
      }
   
      super.update();
    }
  }


const smokeTexture = new THREE.TextureLoader().load('http://stemkoski.github.io/Three.js/images/smokeparticle.png')

/**
 * Smoke particles
 */

// Left smoke stack
const smokeParticlesOne = new SmokeParticleSystem(smokeTexture, 0.8, 6)
smokeParticlesOne.setPosition(new THREE.Vector3(-0.5, 4.8, 2.2))

// Middle smoke stack
const smokeParticlesTwo = new SmokeParticleSystem(smokeTexture, 0.7, 6)
smokeParticlesTwo.setPosition(new THREE.Vector3(-0.5, 4.8, 1.8))

// Right smoke stack
const smokeParticlesThree = new SmokeParticleSystem(smokeTexture, 0.6, 6)
smokeParticlesThree.setPosition(new THREE.Vector3(-0.5, 4.8, 1.4))

// Right house smoke stack
const smokeParticlesFour = new SmokeParticleSystem(smokeTexture, 0.5, 6)
smokeParticlesFour.setPosition(new THREE.Vector3(3.6, 5.3, -3.0))


scene.add(
    smokeParticlesOne.getMesh(),
    smokeParticlesTwo.getMesh(),
    smokeParticlesThree.getMesh(),
    smokeParticlesFour.getMesh()
)



// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

controls.target = new THREE.Vector3(2, 1.5, 0)

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

debugObject.clearColor = '#642638'
renderer.setClearColor(debugObject.clearColor)
gui.addColor(debugObject, 'clearColor').onChange(() => {renderer.setClearColor(debugObject.clearColor)})

renderer.outputEncoding = THREE.sRGBEncoding


/**
 * Animate
 */
const clock = new THREE.Clock()

let currentIntersect = null

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    //Raycast from mouse for hover effects?
    //raycaster.setFromCamera(mouse, camera)

    //Update smoke
    smokeParticlesOne.update()
    smokeParticlesTwo.update()
    smokeParticlesThree.update()
    smokeParticlesFour.update()

    // Update fan position

    // Spinning AC
        const fanOne = scene.getObjectByName( 'fanOne', true )
        if(fanOne) {
            fanOne.rotation.y = elapsedTime * 5
        }

        const fanTwo = scene.getObjectByName( 'fanTwo', true )
        if(fanTwo) {
            fanTwo.rotation.y = elapsedTime * 5
        }


    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()